<button [ngClass]="['bounty-pill', 'bounty-pill--' + size]" [ngStyle]="pillStyles | theme">
    <span class="content" [ngStyle]="labelStyles | theme">
        +{{ formattedAmount }}
    </span>
</button>